import orderBy from 'lodash/orderBy';

export const pages = ({ items }) => orderBy(items, ['id'], ['desc'])
